import React, { useEffect, useState } from "react"
import { graphql, PageProps } from "gatsby"
import getSearchParam from "@ecom/ui/utils/getSearchParam"

import Layout from "../../components/Layouts/mainPage"
import { NewHeader } from "../../components/Headers/NewHeader"
import { Banner as StaticBanner } from "../../components/Banners/Kiberponedelnik"

import { Banner as RoundedDynamicBanner } from "../../components/Banners/DynamicBanners/RoundedDynamicBanner"
import { HowInstallmentWorks } from "../../components/HowInstallmentWorks"
import { FormPKW } from "../../components/FormPKW"
import { NewCalculator } from "../../components/NewCalculator"
import { FourAdvantagesPoints } from "../../components/FourAdvantagesPoints"
import { Partners } from "../../components/PartnersNew"
import { kiberponedelnik } from "../../components/PartnersNew/helpers"
import { NewFooter } from "../../components/NewFooter"
import { TwoChoice } from "../../components/twoChoice"
import { GridWithTooltip } from "../../components/GridWithTooltip"
import { Questions } from "../../components/Questions"
import { QUESTIONS_FOR_HALVA_MEDIA } from "../../components/Questions/helpers"

import { getPageData } from "../../helpers/getPageData"

import { BannerText, getDynamicBannerText } from "../../helpers/getDynamicBannerText"
import { getDynamicBannerUrl } from "../../helpers/getDynamicBannerUrl"

import { PageData } from "../../interfaces/pageProps"

const bannerDescription = `
– Совершайте покупки в интернет-магазинах акции
<br/>
– Регистрируйте чеки и получайте кэшбэк
`

const subTitlePartners = <>Совершайте покупки, регистрируйте чеки и получайте кэшбэк до 100% </>

const firstBlockChoice = (
  <>
    Есть Халва – активируйте акцию!
    <br />
    <span>Не упустите возможность получить кэшбэк до&nbsp;100%</span>
  </>
)

const secondBlockChoice = (
  <>
    Нет Халвы – оформляйте карту <span>и после получения активируйте акцию</span>
  </>
)

const titleForm = (
  <>
    Оформите карту сейчас <br /> и примите участие в акции
  </>
)

// Время для таймер(30мин)
const countDownTime = 1800000

export default function Page({ data }: PageProps<PageData>) {
  const { ligal, noIndex } = getPageData(data)
  const [dynamicBannerTextObj, setDynamicBannerTextObj] = useState<BannerText>()
  const [dynamicBannerImagesObj, setDynamicBannerImagesObj] = useState<any>()

  const bannerTitle = `Кэшбэк до 100% <br/> за онлайн-покупки
  `

  const bannerTextUrl = getSearchParam("h")
  const bannerImageUrl = getSearchParam("bn")

  useEffect(() => {
    if (bannerImageUrl) {
      const bannerImagesData = getDynamicBannerUrl(data.allDynamicBanner, bannerImageUrl)
      if (bannerImagesData !== null) {
        setDynamicBannerImagesObj(bannerImagesData)
      }
    }
  }, [data.allDynamicBanner, bannerImageUrl])

  useEffect(() => {
    if (bannerTextUrl) {
      getDynamicBannerText(bannerTextUrl).then((result) => {
        setDynamicBannerTextObj(result)
      })
    }
  }, [bannerTextUrl])

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  return (
    <Layout
      noHeader
      noFooter
      noIndex={noIndex}
      seoData={{
        title: 'Акция "Киберпонедельник" — кэшбэк до 100% за онлайн-покупки | Совкомбанк',
        description:
          'Участвуйте в акции "Киберпонедельник"! Активируйте предложение в приложении Совкомбанк, покупайте у партнеров и регистрируйте чеки от 3000 ₽. Получите шанс вернуть до 100% кэшбэком.',
      }}
    >
      <NewHeader
        showHint
        countDownTime={countDownTime}
        hint="Совершайте покупки онлайн, регистрируйте чеки и&nbsp;получайте кэшбэк"
        hintTitle={<>Кэшбэк до 100%</>}
      />
      {dynamicBannerImagesObj && bannerImageUrl ? (
        <RoundedDynamicBanner
          large={dynamicBannerImagesObj.dymanicBannerDesk}
          mob={dynamicBannerImagesObj.dymanicBannerMob}
          title={dynamicBannerTextObj ? dynamicBannerTextObj.title : bannerTitle}
          description={dynamicBannerTextObj ? dynamicBannerTextObj.description : bannerDescription}
          orderNum="1"
        />
      ) : (
        <StaticBanner
          description={dynamicBannerTextObj ? dynamicBannerTextObj.description : bannerDescription}
          title={dynamicBannerTextObj ? dynamicBannerTextObj.title : bannerTitle}
          orderNum="1"
        />
      )}
      <FourAdvantagesPoints
        withTitle
        variant="newYearMedia"
        title="Преимущества с Халвой:"
        orderNum="3"
      />
      <HowInstallmentWorks
        headTitle="Как принять участие в&nbsp;акции?"
        variant="kiberponedelnik"
        orderNum="3"
      />
      <FormPKW
        progressBar
        dataLayerName="shortPersonalForm"
        title={titleForm}
        longTitle
        countDownTime={countDownTime}
        withTimer
        formBtnText="Оформить карту"
        orderNum="4"
        isGreenApprove
      />
      <NewCalculator orderNum="5" />
      <Partners
        title="Более 260&nbsp;000 магазинов-партнеров"
        subTitle={subTitlePartners}
        additionalPartners={kiberponedelnik}
        orderNum="6"
      />
      <TwoChoice
        variant="kiberponedelnik"
        orderNum="7"
        textBlockTitle={firstBlockChoice}
        secondTextBlockTitle={secondBlockChoice}
      />
      <GridWithTooltip orderNum="8" />
      <Questions questionList={QUESTIONS_FOR_HALVA_MEDIA} orderNum="9" />
      <NewFooter ligal={ligal} orderNum="10" />
    </Layout>
  )
}

export const query = graphql`
  query {
    allDynamicBanner {
      edges {
        node {
          name
          deskGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [1920, 3840]
              )
            }
          }
          mobGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [600, 1200]
              )
            }
          }
        }
      }
    }
    admin {
      page(url: "https://halvacard.ru/order/pkw/kiberponedelnik/") {
        url
        ligal {
          text
        }
        notIndex
      }
    }
  }
`
